import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trophy } from "lucide-react";
import api, { inr, formatApiErrorDetail } from "@/lib/api";

const inputCls = "bg-transparent border border-white/10 px-3 py-2 text-xs text-white placeholder:text-white/30 gold-focus";

export const AdminLeaderboard = () => {
  const [data, setData] = useState(null);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/leaderboard").then((r) => { setData(r.data); setForm({ enabled: r.data.enabled, prize: r.data.prize, top_n: r.data.top_n }); }).catch(() => {});
  }, []);
  if (!data || !form) return null;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data: saved } = await api.put("/admin/settings/leaderboard", { ...form, top_n: Number(form.top_n) });
      setForm(saved);
      setData((d) => ({ ...d, ...saved }));
      toast.success(`Leaderboard ${saved.enabled ? "on" : "off"} — prize saved`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="admin-leaderboard-section">
      <form onSubmit={save} className="flex flex-wrap items-center gap-4 bg-[#0A0A0A] border border-white/10 px-6 py-4" data-testid="leaderboard-settings-form">
        <div className="flex items-center gap-2 mr-auto">
          <Trophy size={14} className="text-[#D4AF37]" />
          <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-[#D4AF37]">Monthly leaderboard · {data.month}</p>
        </div>
        <input data-testid="leaderboard-prize-input" placeholder="Prize for #1 (e.g. ₹5,000 bonus)" value={form.prize} onChange={(e) => setForm({ ...form, prize: e.target.value })} className={`${inputCls} w-72`} />
        <label className="flex items-center gap-2 text-xs text-white/60">
          Top <input data-testid="leaderboard-topn-input" type="number" min="1" max="50" value={form.top_n} onChange={(e) => setForm({ ...form, top_n: e.target.value })} className={`${inputCls} w-16 text-center`} />
        </label>
        <label className="flex items-center gap-2 text-xs text-white/60">
          <input data-testid="leaderboard-enabled-checkbox" type="checkbox" checked={form.enabled} onChange={(e) => setForm({ ...form, enabled: e.target.checked })} className="accent-[#D4AF37]" /> Show to investors
        </label>
        <button data-testid="leaderboard-save" disabled={busy} className="border border-[#D4AF37] text-[#D4AF37] px-4 py-2 font-accent text-[10px] tracking-[0.2em] uppercase hover:bg-[#D4AF37] hover:text-black transition-colors disabled:opacity-50">Save</button>
      </form>
      <div className="border border-white/10">
        <div className="grid grid-cols-12 gap-4 px-6 py-3 border-b border-white/10 font-accent text-[10px] tracking-[0.2em] uppercase text-white/35">
          <span className="col-span-1">#</span>
          <span className="col-span-4">Referrer</span>
          <span className="col-span-4">Contact</span>
          <span className="col-span-3 text-right">Friends · Invested</span>
        </div>
        {data.rows.map((r) => (
          <div key={r.user_id} className="grid grid-cols-12 gap-4 px-6 py-3 border-b border-white/10 last:border-0 items-center text-xs" data-testid={`admin-leaderboard-row-${r.rank}`}>
            <span className={`col-span-1 font-display text-base ${r.rank === 1 ? "text-[#D4AF37]" : "text-white/50"}`}>{r.rank}</span>
            <span className="col-span-4 text-sm text-white">{r.name}{r.rank === 1 && data.prize && <span className="ml-2 font-accent text-[9px] tracking-[0.15em] uppercase text-[#D4AF37] border border-[#D4AF37]/40 px-1.5 py-0.5">Prize winner</span>}</span>
            <span className="col-span-4 text-white/55">{r.email}<br />{r.phone || "—"}</span>
            <span className="col-span-3 text-right text-white/70">{r.count} · <span className="text-[#D4AF37]">{inr(r.amount)}</span></span>
          </div>
        ))}
        {data.rows.length === 0 && <p className="px-6 py-5 text-sm text-white/40" data-testid="admin-leaderboard-empty">No referrals counted this month yet.</p>}
      </div>
    </div>
  );
};
